module.exports = __webpack_public_path__ + "static/media/image_4.4b90e62c.jpg";